import React, { Fragment } from "react";
import {
	Route,
	Routes,
	Navigate,
} from "react-router-dom";
import { Spin } from "antd";

import Home from "./Pages/Home";
import Login from "./Auth/Login";
import ForgotPassword from "./Auth/ForgotPassword";
import Users from "./Pages/Users";
import Lessons from "./Pages/LessonPages/Lessons";
import Activities from "./Pages/FeedbackPages/Activities";
import Reviews from "./Pages/FeedbackPages/Reviews";
import Priorities from "./Pages/FeedbackPages/Priorities";
import Interactions from "./Pages/FeedbackPages/Interactions";
import Feedback from "./Pages/FeedbackPages/Feedback";
import Tasks from "./Pages/Tasks";
import Consents from "./Pages/FeedbackPages/Consents";
import Surveys from "./Pages/SurveyPages/Surveys";
import Settings from "./Pages/SettingsPages/Settings";
import LessonDetailsV2 from "./Pages/LessonPages/LessonDetailsV2";
import Logs from "./Pages/Logs";
import Groups from "./Pages/GroupPages/Groups";
import SuccessStories from "./Pages/SuccessStories";
import QuizDetails from "./Pages/QuizPages/QuizDetails";
import QuizV2 from "./Pages/QuizPages/QuizV2";
import SurveyDetails from "./Pages/SurveyPages/SurveyDetails";
import SurveyForm from "./Pages/SurveyPages/SurveyForm";
import { useAuth } from "./AuthContext/AuthContext";

const PrivateRoute = ({ user, objectKey, children }) => {
	const { loading, canAccessModule } = useAuth();

	if (loading) {
		return (
			<div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
				<Spin size="large" />
			</div>
		);
	}

	if (!user) {
		return <Navigate to="/login" replace />;
	}

	if (objectKey && !canAccessModule(objectKey, "read")) {
		return <Navigate to="/home" replace />;
	}

	return children;
};

const Navigation = ({ user }) => {
	return (
		<Fragment>
			<Routes>
				<Route path="/login" element={<Login />} />
				<Route path="/forgot" element={<ForgotPassword />} />

				<Route
					path="/"
					element={
						<PrivateRoute user={user}>
							<Home />
						</PrivateRoute>
					}
				/>
				<Route
					path="/home"
					element={
						<PrivateRoute user={user}>
							<Home />
						</PrivateRoute>
					}
				/>
				<Route
					path="/lessons"
					element={
						<PrivateRoute user={user} objectKey="LESSONS">
							<Lessons />
						</PrivateRoute>
					}
				/>
				<Route
					path="/lessons/:id"
					element={
						<PrivateRoute user={user} objectKey="LESSONS">
							<LessonDetailsV2 />
						</PrivateRoute>
					}
				/>
				<Route
					path="/settings"
					element={
						<PrivateRoute user={user} objectKey="ADMIN_CONFIGS">
							<Settings />
						</PrivateRoute>
					}
				/>
				<Route
					path="/interactions"
					element={
						<PrivateRoute user={user} objectKey="INTERACTIONS">
							<Interactions />
						</PrivateRoute>
					}
				/>
				<Route
					path="/feedback"
					element={
						<PrivateRoute user={user} objectKey="FEEDBACK">
							<Feedback />
						</PrivateRoute>
					}
				/>
				<Route
					path="/reviews"
					element={
						<PrivateRoute user={user} objectKey="REVIEWS">
							<Reviews />
						</PrivateRoute>
					}
				/>
				<Route
					path="/priorities"
					element={
						<PrivateRoute user={user} objectKey="COMMUNITY_PRIORITIES">
							<Priorities />
						</PrivateRoute>
					}
				/>
				<Route
					path="/activities"
					element={
						<PrivateRoute user={user} objectKey="LESSON_ACTIVITIES">
							<Activities />
						</PrivateRoute>
					}
				/>
				<Route
					path="/quizzes"
					element={
						<PrivateRoute user={user} objectKey="QUIZZES">
							<QuizV2 />
						</PrivateRoute>
					}
				/>
				<Route
					path="/quizzes/:id"
					element={
						<PrivateRoute user={user} objectKey="QUIZZES">
							<QuizDetails />
						</PrivateRoute>
					}
				/>
				<Route
					path="/tasks"
					element={
						<PrivateRoute user={user} objectKey="TASKS">
							<Tasks />
						</PrivateRoute>
					}
				/>
				<Route
					path="/consents"
					element={
						<PrivateRoute user={user} objectKey="CONSENTS">
							<Consents />
						</PrivateRoute>
					}
				/>
				<Route
					path="/surveys"
					element={
						<PrivateRoute user={user} objectKey="SURVEYS">
							<Surveys />
						</PrivateRoute>
					}
				/>
				<Route
					path="/surveys/:id"
					element={
						<PrivateRoute user={user} objectKey="SURVEYS">
							<SurveyDetails />
						</PrivateRoute>
					}
				/>
				<Route
					path="/surveys/form/:id"
					element={
						<PrivateRoute user={user} objectKey="FORMS">
							<SurveyForm />
						</PrivateRoute>
					}
				/>
				<Route
					path="/groups"
					element={
						<PrivateRoute user={user} objectKey="GROUPS">
							<Groups />
						</PrivateRoute>
					}
				/>
				<Route
					path="/users"
					element={
						<PrivateRoute user={user} objectKey="USERS">
							<Users />
						</PrivateRoute>
					}
				/>
				<Route
					path="/logs"
					element={
						<PrivateRoute user={user} objectKey="LOGS">
							<Logs />
						</PrivateRoute>
					}
				/>
				<Route
					path="/stories"
					element={
						<PrivateRoute user={user} objectKey="SUCCESS_STORIES">
							<SuccessStories />
						</PrivateRoute>
					}
				/>

				<Route
					path="*"
					element={
						user ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />
					}
				/>
			</Routes>
		</Fragment>
	);
};

export default Navigation;
